import { render } from "./CounterpartiesView.vue?vue&type=template&id=00520442&scoped=true"
import script from "./CounterpartiesView.vue?vue&type=script&lang=js"
export * from "./CounterpartiesView.vue?vue&type=script&lang=js"

import "./CounterpartiesView.vue?vue&type=style&index=0&id=00520442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00520442"]])

export default __exports__